<div style="display: inline;">
    <h4 class="loading-title"><ng-content></ng-content></h4>
    <dx-load-indicator [(visible)]="loading" [height]="16" [width]="16"> </dx-load-indicator>
</div>
